export type UserType = 'is_member' | 'is_expert' | 'is_moderator' | '';

export const userTypeOf = (user: any): UserType => {
  if (user?.is_member) return 'is_member';
  if (user?.is_expert) return 'is_expert';
  if (user?.is_moderator) return 'is_moderator';
  return '';
};

export const homeForUserType = (userType: UserType | string | null): string => {
  if (userType === 'is_member') return '/client/anketas/';
  if (userType === 'is_expert') return '/expert/schedule/';
  if (userType === 'is_moderator') return '/admin/';
  return '/';
};

export const homeForUser = (user: any): string => homeForUserType(userTypeOf(user));
